{
    "404": "ああ、大変！海中を探したのですが、ページが見つかりません！"
}
